import { Injectable } from '@angular/core';
import * as moment from 'moment';
import { AuthService } from '../../api';

@Injectable({ providedIn: 'root' })

export class DateTimeService
{
  private _format: string;
  private _locale: string;

  public constructor(private authService: AuthService)
  {
    // this._format = "LL";
    this._format = this.getFormat();
    this._locale = "en-US";

  }

  country_code:any;



  TransformDateFormat(val: any){


    this.authService.user.subscribe(user => {

      this.country_code = user.timezone.country_code;

    });

    var timeformat = "LL";

    switch (this.country_code) {

      case "IN": {
        timeformat = "DD-MM-YYYY";
        break;
      }
      case "US": {
        timeformat = "MM-DD-YYYY";
        break;
      }
      default: {
        timeformat = "DD-MM-YYYY";
      }
    }

    // return timeformat;
    if (val != undefined) {
      return moment(val).format(timeformat);

    }
    else {
      return '';
    }
  }

  getFormat(){


    this.authService.user.subscribe(user => {

      this.country_code = user.timezone.country_code;

    });

    var timeformat = "LL";

    switch (this.country_code) {

      case "IN": {
        timeformat = "DD-MM-YYYY";
        break;
      }
      case "US": {
        timeformat = "MM-DD-YYYY";
        break;
      }
      default: {
        timeformat = "DD-MM-YYYY";
      }
    }

    return timeformat;
  }

  public get format(): string
  {
    return this._format;
  }
  public set format(value: string)
  {
    this._format = value;
  }

  public get locale(): string
  {
    return this._locale;
  }
  public set locale(value: string)
  {
    this._locale = value;
  }
}
